import React from 'react';
import Button from '../../../components/ui/Button';

const ModalFooter = ({ selectedRole, onContinue, onClose, isLoading }) => {
  return (
    <div className="flex items-center justify-between p-8 pt-6 border-t border-border bg-muted/20">
      <div className="flex items-center space-x-2 text-sm text-muted-foreground">
        <span>Need help deciding?</span>
        <button 
          onClick={onClose}
          className="text-primary hover:text-primary/80 font-medium transition-colors"
        >
          Browse homepage first
        </button>
      </div>
      
      <div className="flex items-center space-x-4">
        <Button variant="ghost" onClick={onClose} disabled={isLoading}>
          Maybe Later
        </Button>
        
        <Button 
          onClick={onContinue}
          disabled={!selectedRole || isLoading}
          loading={isLoading}
          iconName="ArrowRight"
          iconPosition="right"
          size="lg"
        >
          Continue to Registration
        </Button>
      </div>
    </div>
  );
};

export default ModalFooter;